<template>
  <div class="fabric-content-box">
    <div class="fabric-content-wrap">
      <div class="info-wrap">
        <div class="flex justify-around">
          <div class="left-popup">
            <div
              v-if="detail.image_list.length > 0 || detail.video"
              class="slider"
            >
              <swiper ref="swiper" :options="swiperOption">
                <swiper-slide v-if="detail.video">
                  <video
                    v-if="detail.video"
                    :src="detail.video"
                    muted
                    autoplay
                    controls
                    id="video-material"
                  >
                    您的浏览器不支持视频播放。
                  </video>
                </swiper-slide>
                <swiper-slide
                  v-for="(item, index) in detail.image_list"
                  :key="`sl` + index"
                >
                  <!-- <img v-viewer :src="item.url" class="img" /> -->
                   <img :src="detail.image_list[curr_slider_index].url" v-viewer alt="" class="img">
                </swiper-slide>
                <div slot="button-prev" class="swiper-button-prev" @click.prevent.stop="onChangeSlider('prev')"></div>
                <div slot="button-next" class="swiper-button-next" @click.prevent.stop="onChangeSlider('next')"></div>
              </swiper>
            </div>
            <div class="img-list-box">
              <img v-for="(item,index) in detail.image_list" :key="index" @click="curr_slider_index=index" :src="item.url" alt="" :class="['img-item',{active:index === curr_slider_index}]">
            </div>
          </div>
          <div class="right" v-if="type == 'fabric'">
            <p class="name">{{ detail.fabric_name_cn || detail.goods_no }}</p>
            <!-- <p class="no">面料编号：{{ detail.fabric_key }}</p> -->
            <p class="price" v-if="detail.fabric_price>0">
              价格:¥{{ detail.fabric_price
              }}{{ detail.unit ? "/" + detail.unit : "" }}
            </p>
            <p class="price" v-else>咨询客服</p>
            <div
              class="title"
              style="border-top: 1px solid #e0e0e0; margin-bottom: 20px"
            ></div>
            <div class="list">
              <div class="item">
                <span class="key">货号：</span><span class="value">{{ detail.goods_no || '-' }}</span>
              </div>
              <div class="item">
                <span class="key">分类：</span><span class="value">{{ detail.category_name || '-' }}</span>
              </div>
              <div class="item">
                <span class="key">成分：</span><span class="value">{{ detail.component }}</span>
              </div>
              <div class="item">
                <span class="key">克重：</span><span class="value">{{ detail.weight }}</span>
              </div>
             <div class="item">
                <span class="key">幅宽：</span><span class="value">{{ detail.width_desc }}</span>
              </div>
              <div class="item">
                <span class="key">国标：</span><span class="value">{{ detail.standard }}</span>
              </div> 
              <div class="item">
                <span class="key">织物：</span><span class="value">{{ detail.zhiwu || '-' }}</span>
              </div>
              <div class="item">
                <span class="key">面料功能：</span><span class="value">{{ detail.gongneng || '-' }}</span>
              </div>
              <div class="item">
                <span class="key">织法：</span><span class="value">{{ detail.zhifa || '-' }}</span>
              </div>
              <div class="item">
                <span class="key">单位：</span><span class="value">{{ detail.unit }}</span>
              </div>
              <div class="item">
                <span class="key">提供寄样服务：</span><span class="value">{{detail.is_support_send_sample ? "是" : "否"}}</span>
              </div>
            </div>
          </div>
          <div class="right" v-else>
            <p class="name">{{ detail.accessory_name }}</p>
            <p class="no">辅料编号：{{ detail.accessory_sku }}</p>

            <div
              class="title"
              style="border-top: 1px solid #e0e0e0; margin-bottom: 20px"
            ></div>
            <div class="list">
              <div class="item">
                <span class="key">单位：</span
                ><span class="value">{{ detail.measure_unit }}</span>
              </div>
              <div class="item">
                <span class="key">规格：</span
                ><span class="value">{{ detail.spec }}</span>
              </div>
              <div class="item">
                <span class="key">材质：</span
                ><span class="value">{{ detail.material }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="color-title">颜色分类({{ detail.color_list.length }}):</div>

        <div class="color-box">
          <div :class="['color-items',{active:detail.color_name_cn === item.color_name_cn}]" v-for="(item,index) in detail.color_list" :key="index">
            <div class="item-top">
              <span class="color-img" v-if="item.rgb" :style="{'background-color':item.rgb}"></span>
              <img v-else v-viewer @click.stop :src="item.color_value | default_img" alt="" class="color-img"/>
              <div class="color-name" :title="`${item.color_name_cn}`">{{ item.color_name_cn }}</div>
            </div>
            <div class="info-item">
              <div class="label">C卡色号:</div>
              <div class="value">{{ item.pantoneC }}</div>
            </div>
            <div class="info-item">
              <div class="label">TCX色号:</div>
              <div class="value">{{ item.pantoneTcx }}</div>
            </div>
            <div class="info-item">
              <div class="label">TPG色号:</div>
              <div class="value">{{ item.pantoneTpg }}</div>
            </div>
          </div>
        </div>
      </div>
      <template v-if="detail.description">
        <div class="title-box">
          <div class="title">产品详情</div>
        </div>
        <div class="richtext-wrap" v-html="detail.description"></div>
      </template>
    </div>
  </div>
</template>

<script>
import { GetAccessory, GetFabric } from "@/api";
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  name: "Lab",
  data() {
    return {
      swiperOption: {
        loop: false, // 循环播放, 可有无限滚动效果，初始加载即是滚动后的效果
        autoplay: false,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        on: {
          slideChange: function () {
            if (document.getElementById("video-material")) {
              if (this.activeIndex === 0) {
                document.getElementById("video-material").play();
              } else {
                document.getElementById("video-material").pause();
              }
            }
          },
        },
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
      },
      detail: {
        image_list: [],
        color_list: [],
      },
      id: 0,
      type: "fabric",
      curr_slider_index:0
    };
  },
  components: {
    swiper,
    swiperSlide,
  },
  mounted() {
    if (this.$route.query.id) {
      const { id, type } = this.$route.query;
      this.id = id;
      this.type = type;
    } else {
      const { id, type } = this.$route.params;
      this.id = id;
      this.type = type;
    }

    this.get();
  },
  methods: {
    onChangeSlider(type){
      console.log('type---->',type);
      const {curr_slider_index} = this;
      if(curr_slider_index === 0 && type === 'prev'){
        this.curr_slider_index = this.detail.image_list.length - 1;
        return;
      }
      if(curr_slider_index === this.detail.image_list.length - 1 && type === 'next'){
        this.curr_slider_index = 0;
        return;
      }
      this.curr_slider_index = type == "prev" ? curr_slider_index - 1 : curr_slider_index + 1;
    },
    async get() {
      if (this.type == "fabric") {
        var { data } = await GetFabric({
          id: this.id,
        });
      } else {
        var { data } = await GetAccessory({
          id: this.id,
        });
      }
      this.detail = data;
    },
  },
};
</script>

<style lang="scss" scoped>
.fabric-content-box {
  background: #f8f6f9;
}
.fabric-content-wrap {
  width: 1200px;
  margin: 0px auto;
  top: 30px;
  position: relative;
  display: flex;
  flex-direction: column;
  .title-box {
    display: flex;
    align-items: center;
    column-gap: 13px;
    background: #ffffff;
    border-radius: 5px;
    margin-top: 10px;
    .title {
      color: #1a1a1a;
      font-size: 16px;
      border-left: none;
      font-weight: bold;
      margin-bottom: 0;
      padding: 30px 40px;
      height: auto;
    }
  }

  .info-wrap {
    background: #ffffff;
    border-radius: 5px;
    padding: 30px;
    margin-bottom: 100px;
    .left-popup {
      width: 500px;
      .f-img {
        width: 500px;
        height: 500px;
      }
    }

    .right {
      flex: 1;
      padding-right: 20px;
      padding-left: 20px;
      .name {
        color: #1a1a1a;
        font-size: 20px;
      }
      .no {
        color: #808080;
        font-size: 14px;
        margin-bottom: 20px;
        margin: 10px 0;
        display:flex;
        align-items:center;
        column-gap:15px;
      }
      .price {
        color: #e00000;
        font-size: 18px;
        font-weight: bold;
        padding-bottom: 17px;
      }
      .item {
        margin: 5px 0;

        .key {
          display: inline-block;
          color: #808080;
          // width: 80px;
        }

        .value {
          color: #1a1a1a;
        }
      }
    }
    .color-title {
      color: #1a1a1a;
      font-size: 16px;
      font-weight: bold;
      margin-top: 40px;
    }
    .color-box {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      gap: 10px;
      margin-top: 26px;
      .color-items{
        user-select:none;
        width:180px;
        border:1px solid #e3e3e3;
        border-radius:4px;
        padding:8px;
        display:flex;
        flex-direction:column;
        row-gap:4px;
        &.active{
          border:1px solid #ff5967;
        }
        .item-top{
          display:flex;
          align-items:center;
          column-gap: 8px;
          .color-img{
            width:30px;
            height:30px;
            border:1px solid #e3e3e3;
            border-radius:4px;
          }
          .color-name{
            font-size:12px;
            color:#333;
            font-weight:500;
          }
        }
        .info-item{
          display:flex;
          align-items:center;
          column-gap:5px;
          .label{
            color:#999;
            font-size:12px;
            flex-shrink:0;
          }
          .value{
            color:#666;
            font-size:12px;
            white-space:pre-wrap;
            word-break:break-all;
          }
        }
      }
    }
  }

  .richtext-wrap {
    flex: 1;
    padding-bottom: 60px;
    background: #fff;
    margin-bottom: 100px;
    padding: 0 8.75%;
  }
}

.slider {
  width: 500px;
  height: 500px;
  overflow: hidden;
  border: 1px solid #e5e5e5;
  .swiper-slide {
    width: 500px;
    height: 500px;
  }

  .img,
  video {
    width: 500px;
    height: 500px;
    object-fit: contain;
  }
}

.img-list-box{
  display:flex;
  align-items:center;
  width:100%;
  flex-wrap:wrap;
  gap:10px;
  margin-top:10px;
  .img-item{
    width:60px;
    height:60px;
    border:2px solid #e0e0e0;
    border-radius:10px;
    cursor:pointer;
    &.active,&:hover{
      border:2px solid #fa3d5a;
    }
  }
}

::v-deep .viewer-container {
  z-index: 999999 !important;
}
</style>
